import { ErrorContainer } from './error-container.component';
export default ErrorContainer;
